import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { BorderedBottomTabs, CustomNavLink, NavItem } from '@spark/ui-components/components/Tabs';
import { Nav } from 'react-bootstrap';
import DetalhesTab from '../Tabs/Detalhes';
import AcompanhamentosTab from '../Tabs/Acompanhamentos';
import PedidosTab from '../Tabs/Pedidos';
import EncerramentoTab from '../Tabs/Encerramento';

const TabsContainer = ({
  activeTab,
  setActiveTab,
  depotId,
  depot
}) => {
  const tabs = [{
    id: 'detalhes',
    label: 'Detalhes',
    component: DetalhesTab
  }, {
    id: 'acompanhamentos',
    label: 'Acompanhamentos',
    component: AcompanhamentosTab
  }, {
    id: 'pedidos',
    label: 'Pedidos',
    component: PedidosTab
  }, {
    id: 'encerramento',
    label: 'Encerramento',
    component: EncerramentoTab
  }
  ];

  const renderTabContent = () => {
    const currentTab = tabs.find(tab => tab.id === activeTab);
    if (!currentTab) return null;
    const TabComponent = currentTab.component;
    return <TabComponent depotId={depotId} depot={depot} />;
  };

  return <>
    <Row>
      <Col md={12}>
        <BorderedBottomTabs className="mb-3">
          <Nav variant="tabs" className="nav-tabs">
            {tabs.map(tab => <NavItem key={tab.id}>
              <CustomNavLink active={activeTab === tab.id} onClick={() => setActiveTab(tab.id)}>
                <span className="tab-text">{tab.label}</span>
              </CustomNavLink>
            </NavItem>)}
          </Nav>
        </BorderedBottomTabs>
      </Col>
    </Row>

    {renderTabContent()}
  </>;
};

export default TabsContainer;
